import RestClient from '../../../lib/RestClient';

const URL = 'file/';

class FileService {
    public getAllData(
        filter: String, section: String, language: String, pageToLoad: number, count: number
    ) {
        return RestClient.get(URL, {filter: filter, section:section, language:language, page: pageToLoad, count: count});
    }

    public downloadFile(objectId: any, name:any) {

        let a = document.createElement('a');
        let body = document.getElementsByTagName("body");

        // @ts-ignore
        body.item(0).appendChild(a);

        if (name != null)
            a.download = name;

        a.href = RestClient.baseUrl + URL + objectId;
        a.click();
        // @ts-ignore
        a.parentNode.removeChild(a);
    }

}

const FileServiceInstance = new FileService();

export default FileServiceInstance;
